import gql from 'graphql-tag';

export const GET_ORG_TEMPLATES = gql`
  query GetOrgTemplates($request: AWSJSON!) {
    getOrgTemplates(request: $request)
  }
`;

export const GET_ORG_FINDING_TYPES = gql`
  query GetOrgFindingTypes($request: AWSJSON!) {
    getOrgFindingTypes(request: $request)
  }
`;

export const GET_TEMPLATE_FINDING_TYPES = gql`
  query GetTemplateFindingTypes($request: AWSJSON!) {
    getTemplateFindingTypes(request: $request)
  }
`;

export const GET_ORG_ZONES = gql`
  query GetOrgZones($request: AWSJSON!) {
    getOrgZones(request: $request)
  }
`;
